import "./rightColumn.css";
import Profile from "../../components/rightColumn/ProfilePicture/Profile";

export function WhoAmI() {
  return (
    <div className="div1">
      <Profile />
    </div>
  );
}

export default WhoAmI;
